import { unsupportedFileTypeDefaultMsg, uploadAccepts, isValidFileBeforeUpload } from './file-upload-accepts';

async function readLocalFiles() {
  return new Promise((resolve, reject) => {
    const uploadInput = document.createElement('input');

    uploadInput.addEventListener('change', (_) => {
      const files = Array.from(uploadInput.files);
      resolve(
        files.map((f) => {
          const isValidFile = isValidFileBeforeUpload(f.name, f.type);

          return {
            file: {
              type: f.type,
              name: f.name,
              size: f.size,
              file: f,
            },
            isValidFile: isValidFile,
            description: !isValidFile ? unsupportedFileTypeDefaultMsg : '',
          };
        }),
      );
    });

    // This input element in IE11 becomes visible after it is added on the page
    // Hide an input element
    uploadInput.style.visibility = 'hidden';

    uploadInput.type = 'file';
    uploadInput.multiple = true;
    document.body.appendChild(uploadInput);
    uploadInput.click();
    document.body.removeChild(uploadInput);
  });
}

async function readLocalFolders() {
  return new Promise((resolve, reject) => {
    const uploadInput = document.createElement('input');

    uploadInput.addEventListener('change', (_) => {
      const files = Array.from(uploadInput.files);
      resolve(
        files.map((f) => {
          const isValidFile = isValidFileBeforeUpload(f.name, f.type);

          return {
            file: {
              type: f.type,
              name: f.name,
              size: f.size,
              file: f,
            },
            isValidFile: isValidFile,
            description: !isValidFile ? unsupportedFileTypeDefaultMsg : '',
          };
        }),
      );
    });

    // This input element in IE11 becomes visible after it is added on the page
    // Hide an input element
    uploadInput.style.visibility = 'hidden';

    uploadInput.type = 'file';
    uploadInput.multiple = true;
    uploadInput.directory = true;
    uploadInput.webkitdirectory = true;
    document.body.appendChild(uploadInput);
    uploadInput.click();
    document.body.removeChild(uploadInput);
  });
}

export { readLocalFiles, readLocalFolders };
